<template>
    <div>
        <v-currency-field
                :id="name" :name="name"
                :label="label"
                outlined
                hint='Press "Enter" when done'
                :readonly="readonly"
                @keydown="removeFocusWhenDone"
                :disabled="disabled"
                @focus="$event.target.select()"
                prefix="$"
                v-model.lazy="updatedPrice"
                v-bind:value="updatedPrice"
                v-on:change="$emit('input', updatedPrice)"
        />
        <div v-if="debug">
        Original Price: {{ originalPrice }}<br/>
        Updated Price: {{ updatedPrice }}<br/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'EditPrice',
  props: ['originalPrice', 'name', 'label', 'readonly', 'disabled'],
  data: function () {
    return {
      updatedPrice: this.originalPrice,
      debug: false
    }
  },
  watch: {
    originalPrice: function () {
      this.updatedPrice = this.originalPrice
      this.$emit('input', this.updatedPrice)
    }
  },
  methods: {
    removeFocusWhenDone (event) {
      if (event.keyCode === 13) {
        $('#' + this.name).blur()
        if (event.target) event.target.blur()
        return false
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../../node_modules/vuetify/dist/vuetify.min.css';
    .v-messages__message {
        margin-left: -10px;
        font-size: 1.4em;
    }

</style>



// WEBPACK FOOTER //
// src/components/EditPrice.vue